// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"736da600","57":"43dfc9aa","355":"705d9a2f","384":"96e0dc66","443":"71fb1a0e","488":"2e5732bd","977":"8ece8614"}[chunkId] + ".chunk.js";
};